import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Order } from '@/models';

@Component({
  name: 'CmgTaxAndFees',
})
export default class CmgTaxAndFees extends Vue {
  isExpanded = false;

  @Prop({ required: true, type: Object })
  order!: Order;

  formatTotal(total: number | null): string {
    return this.$services.utils.formatPrice(total);
  }

  get isDelivery(): boolean {
    return this.$services.order.isDelivery();
  }

  get hasServiceFee(): boolean {
    return this.order.taxesAndFees.deliveryServiceFee > 0;
  }

  get hasTaxesAndFees(): boolean {
    return !!this.order.taxesAndFees;
  }

  onClickToggleExpandedContentVisibility() {
    if (this.hasServiceFee) {
      this.isExpanded = !this.isExpanded;
    }
  }
}
